import React from 'react';
import {Container, Divider, Stack, Text, Title, useMantineTheme} from '@mantine/core';
import {useConfig} from '../ConfigContext';

/**
 * Legal copy reads as one column, not a card grid — long paragraphs chopped into
 * three narrow columns are close to unreadable, and numbered sections need to be
 * followed in order.
 */
const Privacy: React.FC = () => {
    const theme = useMantineTheme();
    const {privacy} = useConfig();

    return (
        <Container size="md" py="xl">
            <Stack gap="xs" mb="xl">
                <Title order={1} c={theme.colors.brand[6]}>Privacy Policy</Title>
                <Text size="sm" c="dimmed">Last updated: {privacy.lastUpdated}</Text>
            </Stack>

            <Stack gap="sm" mb="xl">
                {privacy.intro.map((paragraph, index) => (
                    <Text key={index} size="lg">{paragraph}</Text>
                ))}
            </Stack>

            <Divider mb="xl"/>

            <Stack gap="xl">
                {privacy.sections.map((section, index) => (
                    <Stack key={section.title} gap="sm">
                        <Title order={2} size="h3">
                            {index + 1}. {section.title}
                        </Title>
                        {section.paragraphs.map((paragraph, idx) => (
                            <Text key={idx} style={{lineHeight: 1.6}}>
                                {paragraph}
                            </Text>
                        ))}
                    </Stack>
                ))}
            </Stack>
        </Container>
    );
};

export default Privacy;
